import { lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";

import { docUploadModalClose } from "../../../redux/actions/docUploadModalActions";

// The inner modal pulls in the (large) Documents-tab upload machinery, so it's
// lazy-loaded — the chunk isn't fetched until the modal is actually opened.
const LoanDocumentUploadModalInner = lazy(
  () => import("./LoanDocumentUploadModalInner"),
);

/**
 * LoanDocumentUploadModal — global host for the reusable, full-screen
 * loan-document uploader. Mounted once in LoanDrilldownScreen; opened from
 * anywhere in the drilldown via `dispatch(docUploadModalOpen(assignTo))`.
 *
 * `assignTo`:
 *   - null                                       → upload directly to the loan
 *                                                  (queue's Assign-to picker shown).
 *   - { type: "borrower"|"property", id, label } → locks upload to that entity
 *                                                  (picker hidden, "Assigning to …"
 *                                                  chip shown instead).
 */
const LoanDocumentUploadModal = () => {
  const dispatch = useDispatch();
  const { open, assignTo, initialView, initialFiles } = useSelector(
    (state) => state.docUploadModal || {},
  );

  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <LoanDocumentUploadModalInner
        assignTo={assignTo}
        initialView={initialView}
        initialFiles={initialFiles}
        onClose={() => dispatch(docUploadModalClose())}
      />
    </Suspense>
  );
};

export default LoanDocumentUploadModal;
